import {
  Box,
  Container,
  FormControlLabel,
  FormLabel,
  Grid,
  Switch,
  Typography,
  useMediaQuery,
} from '@mui/material'
import { Topbar, Page } from 'components'
import { theme } from 'config'
import { inject, observer } from 'mobx-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { AuthStore, RoutingStore } from 'stores'
import { MainSidebar } from 'views'
import { BankIdSettings } from './bankIdSettings'
import { UserForm } from './userForm'

export interface IUserSettingsProps {
  authStore?:        AuthStore
  routingStore?:     RoutingStore
  showHelpSettings?: boolean
}

/**
 * Displays account settings for user.
 *
 * @type Participant, Editor, Group
 */

export const UserSettings = inject(
  'authStore',
  'routingStore'
)(
  observer((props: IUserSettingsProps) => {
    const { routingStore, showHelpSettings } = props
    const { t } = useTranslation()
    const isNotMobileView = useMediaQuery(theme.breakpoints.up('sm'))

    return (
      <Page sidebar={<MainSidebar />} topbar={<Topbar />}>
        <Container sx={{ padding: !isNotMobileView && 4 }} maxWidth='md'>
          <Grid container rowSpacing={1} columnSpacing={theme.columnSpacing}>
            <Grid item xs={12}>
              <Typography variant='h4' mb={3}>
                {t('account')}
              </Typography>
            </Grid>
            <UserForm />
            <Grid item xs={12} flexDirection='column' md={6}>
              {showHelpSettings && (
                <Box
                  display        = 'flex'
                  justifyContent = 'flex-start'
                  flexDirection  = 'column'
                >
                  <FormLabel>{t('show_help_button')}</FormLabel>
                  <FormControlLabel
                    sx             = {{ flexDirection: 'row' }}
                    label          = {t('show_help_button')}
                    labelPlacement = 'end'
                    control        = {
                      <Switch
                        checked  = {routingStore.showHelpButton}
                        onChange = {routingStore.toogleShowHelpButton}
                      />
                    }
                  />
                </Box>
              )}
              <BankIdSettings />
            </Grid>
          </Grid>
        </Container>
      </Page>
    )
  })
)
